/* Lightweight client-side SEO head manager for SPA pages (blog).
   Google renders JS and reads these; sets title, meta, canonical, OG + JSON-LD. */

function upsertMeta(key, attr, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function setSeo({ title, description, canonical, image, url, type = 'website', jsonld } = {}) {
  if (title) document.title = title;
  if (description) upsertMeta('description', 'name', description);
  upsertLink('canonical', canonical);
  upsertMeta('og:title', 'property', title);
  upsertMeta('og:description', 'property', description);
  upsertMeta('og:type', 'property', type);
  upsertMeta('og:url', 'property', url);
  upsertMeta('og:image', 'property', image);
  upsertMeta('twitter:title', 'name', title);
  upsertMeta('twitter:description', 'name', description);
  upsertMeta('twitter:image', 'name', image);

  let s = document.getElementById('page-jsonld');
  if (jsonld) {
    if (!s) {
      s = document.createElement('script');
      s.id = 'page-jsonld';
      s.type = 'application/ld+json';
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(jsonld);
  } else if (s) {
    s.remove();
  }
}

export function clearPageJsonLd() {
  const s = document.getElementById('page-jsonld');
  if (s) s.remove();
}
